module.exports = __webpack_public_path__ + "static/media/plenny.d726f693.png";